export default "__VITE_ASSET__80f08473__"